module.exports = __webpack_public_path__ + "static/media/bnoble-logo.f305e4b8.png";